const NotificationTypes = {
    welcome: 1,
    payment_created: 2,
    payment_reminder: 3,
    payment_due: 4,
    support_request_created: 5,
    support_request_updated: 6,
    password_reset: 7,
    login: 8,
} as const;

const Status = {
    deleted: 0,
    active: 1,
} as const;

const NotificationSubjects = {
    1: 'Welcome to the Auxcap Customer Portal',
    2: 'Paymnt created for contract',
    3: 'Payment reminder for your contract',
    4: 'Payment due for your contract',
    5: 'Support request created',
    6: 'Support request updated to status',
} as const;

const NotificationMessages = {
    1: 'Welcome to the Auxcap Customer Portal',
    2: 'Paymnt created for contract',
    3: 'Payment reminder for your contract',
    4: 'Payment due for your contract',
    5: 'Support request created',
    6: 'Support request updated to status',
} as const;

const PushNotificationsTitle = {
    title: 'Auxcap Customer Portal',
} as const;

const Platforms = {
    ios: 1,
    android: 2,
} as const;

export { NotificationTypes, Status, NotificationSubjects, NotificationMessages, PushNotificationsTitle, Platforms };
